import React from 'react';
import Logo from '../Assets/foooterrrrrrrrrrrrrr.png';

const footer = () => {
  return (
    <footer className="bg-[#020617] text-slate-400 pt-[80px] text-[14px] font-sans">
      {/* Import Playfair Display font for headings */}
      <style>
        {`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&display=swap');`}
      </style>

      <div className="max-w-[1200px] mx-auto px-5 grid grid-cols-1 lg:grid-cols-[1.2fr_1.8fr] gap-[50px] border-b border-slate-800/60 pb-[50px] mb-[50px] items-center">
        <div className="max-w-[400px]">
          <img src={Logo} alt="SENVRA AI" className="h-[50px] rounded mb-6" />
          <p className="text-slate-400 text-[15px] leading-relaxed">
            Empowering the next generation of tech leaders through virtual internships, hands-on coding practice, and industry-standard mentorship.
          </p>
        </div>
        
        {/* Newsletter Box styling updated as per screenshot */}
        <div className="bg-[#0A0F1C] border border-slate-800/60 p-8 rounded-2xl shadow-[0_0_30px_rgba(2,132,199,0.03)] w-full lg:max-w-[600px] lg:ml-auto">
          <h3 className="text-white text-[22px] font-bold mb-2 tracking-wide" style={{ fontFamily: "'Playfair Display', serif" }}>Join our Newsletter</h3>
          <p className="text-slate-400 text-[14px] mb-5">Get the latest internship updates, tech tutorials, and exclusive resources weekly.</p>
          <div className="flex flex-col sm:flex-row gap-3">
            <input type="email" placeholder="Enter your email" className="flex-1 bg-[#020617] border border-slate-700/80 p-3.5 rounded-lg text-white text-[14px] outline-none focus:border-[#0284C7] transition-colors" />
            <button className="py-3.5 px-6 rounded-lg font-bold text-[15px] bg-[#0284C7] hover:bg-[#0369A1] text-white border-none cursor-pointer transition-colors flex items-center justify-center gap-2 shadow-lg shadow-sky-900/20">
              Subscribe
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 2L11 13"></path><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>
            </button>
          </div>
        </div>
      </div>
      
      {/* Links mapped exactly to the screenshot text with proper fonts and spacing */}
      <div className="max-w-[1200px] mx-auto px-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[40px] mb-[50px]">
        <div>
          <h4 className="text-white text-[20px] font-semibold mb-6 tracking-wide" style={{ fontFamily: "'Playfair Display', serif" }}>Explore</h4>
          <a href="/dashboards" className="block text-slate-300 text-[15px] no-underline mb-4 transition-colors hover:text-white">Skill Course Dashboard</a>
          <a href="/browse-courses" className="block text-slate-300 text-[15px] no-underline mb-4 transition-colors hover:text-white">Skill Courses</a>
          <a href="/my-certificates" className="block text-slate-300 text-[15px] no-underline mb-4 transition-colors hover:text-white">Skill Certificate Verification</a>
          <a href="/apply" className="block text-slate-300 text-[15px] no-underline mb-4 transition-colors hover:text-white">Internship Registration</a>
          {/* <a href="/skill-certificate-verification" className="block text-slate-300 text-[15px] no-underline mb-4 transition-colors hover:text-white">Internship Certificate Verification</a> */}
        </div>
        <div>
          <h4 className="text-white text-[20px] font-semibold mb-6 tracking-wide" style={{ fontFamily: "'Playfair Display', serif" }}>Company</h4>
          <a href="/" className="block text-slate-300 text-[15px] no-underline mb-4 transition-colors hover:text-white">About Us</a>
          <a href="/contact" className="block text-slate-300 text-[15px] no-underline mb-4 transition-colors hover:text-white">Support Hub</a>
          <a href="/terms-and-conditions" className="block text-slate-300 text-[15px] no-underline mb-4 transition-colors hover:text-white">Terms & Conditions</a>
          <a href="/privacy-policy" className="block text-slate-300 text-[15px] no-underline mb-4 transition-colors hover:text-white">Privacy Policy</a>
          <a href="/cookies-policy" className="block text-slate-300 text-[15px] no-underline mb-4 transition-colors hover:text-white">Cookies Policy</a>
        </div>
        <div>
          <h4 className="text-white text-[20px] font-semibold mb-6 tracking-wide" style={{ fontFamily: "'Playfair Display', serif" }}>Resources</h4>
          <a href="/ats-score" className="block text-slate-300 text-[15px] no-underline mb-4 transition-colors hover:text-white">ATS Checker</a>
          <a href="/interview-prep" className="block text-slate-300 text-[15px] no-underline mb-4 transition-colors hover:text-white">Interview Preparation</a>
          <a href="/email-builder" className="block text-slate-300 text-[15px] no-underline mb-4 transition-colors hover:text-white">Job Email Builder</a>
          <a href="/contact" className="block text-slate-300 text-[15px] no-underline mb-4 transition-colors hover:text-white">Help Center</a>
        </div>
        <div>
          <h4 className="text-white text-[20px] font-semibold mb-6 tracking-wide" style={{ fontFamily: "'Playfair Display', serif" }}>Contact Us</h4>
          
          {/* ---- మార్పు చేసిన భాగం: చిరునామా ఇప్పుడు క్లిక్ చేయదగిన లింక్ గా మారింది ---- */}
          <a 
            href="https://www.google.com/maps/@17.4008831,78.5568002,16z?entry=ttu&g_ep=EgoyMDI2MDQyOS4wIKXMDSoASAFQAw%3D%3D" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="mb-5 flex items-start gap-4 text-slate-300 text-[15px] no-underline transition-colors hover:text-white group"
          >
            <span className="w-8 h-8 rounded-lg bg-slate-800/80 flex items-center justify-center shrink-0 text-[#0284C7] border border-slate-700/50 transition-colors group-hover:bg-[#0284C7] group-hover:text-white group-hover:border-[#0284C7]">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
            </span>
            <span className="mt-1 group-hover:text-white transition-colors">Hyderabad, Telangana, India</span>
          </a>
          {/* --------------------------------------------------------------------- */}

          {/* <p className="mb-5 flex items-start gap-4 text-slate-300 text-[15px]">
            <span className="w-8 h-8 rounded-lg bg-slate-800/80 flex items-center justify-center shrink-0 text-[#0284C7] border border-slate-700/50">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
            </span>
            <span className="mt-1">+91 9336576683</span>
          </p> */}
          <p className="mb-5 flex items-start gap-4 text-slate-300 text-[15px]">
  <a
    href="mailto:senvraai@gmail.com"
    className="flex items-start gap-4 group"
  >
    <span className="w-8 h-8 rounded-lg bg-slate-800/80 flex items-center justify-center shrink-0 text-[#0284C7] border border-slate-700/50 group-hover:bg-slate-700/80 transition-colors">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
        <polyline points="22,6 12,13 2,6"></polyline>
      </svg>
    </span>
    <span className="mt-1 group-hover:text-[#0284C7] transition-colors">senvraai@gmail.com</span>
  </a>
</p>
          {/* <p className="mb-5 flex items-start gap-4 text-slate-300 text-[15px]">
            <span className="w-8 h-8 rounded-lg bg-slate-800/80 flex items-center justify-center shrink-0 text-[#0284C7] border border-slate-700/50">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
            </span>
            <span className="mt-1">www.senvraai.com</span>
          </p> */}
        </div>
      </div>

      <div className="border-t border-slate-800/60 bg-[#020617] py-6">
        <div className="max-w-[1200px] mx-auto px-5 flex flex-col lg:flex-row justify-between items-center gap-5 text-center lg:text-left">
          <p className="text-[14px] text-slate-400">© 2026 SENVRA AI. All rights reserved.</p>
          
          <div className="flex gap-3">
  {/* LinkedIn - Updated with <a> tag */}
  <a
    href="https://www.linkedin.com/company/senvra-ai"
    target="_blank"
    rel="noopener noreferrer"
    className="inline-flex w-[36px] h-[36px] rounded-full bg-slate-800/80 border border-slate-700/50 items-center justify-center cursor-pointer transition-colors hover:bg-[#0284C7] hover:border-[#0284C7] text-slate-300 hover:text-white"
  >
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
      <rect x="2" y="9" width="4" height="12"></rect>
      <circle cx="4" cy="4" r="2"></circle>
    </svg>
  </a>
 
 
 
  {/* Instagram - Added <a> tag wrapper */}
  <a
    href="https://www.instagram.com/senvra_ai?igsh=MW5hMWV6bGg0N2kzOA=="
    target="_blank"
    rel="noopener noreferrer"
    className="inline-flex w-[36px] h-[36px] rounded-full bg-slate-800/80 border border-slate-700/50 items-center justify-center cursor-pointer transition-colors hover:bg-[#0284C7] hover:border-[#0284C7] text-slate-300 hover:text-white"
  >
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
    </svg>
  </a>
 
 
</div>

          
          <div className="flex gap-6 text-[14px]">
            <a href="/privacy-policy" className="text-slate-400 no-underline transition-colors hover:text-white">Privacy Policy</a>
            <a href="/terms-and-conditions" className="text-slate-400 no-underline transition-colors hover:text-white">Terms of Service</a>
            <a href="/cookies-policy" className="text-slate-400 no-underline transition-colors hover:text-white">Cookies Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default footer;